'use client';

import { Button } from '@modules/common/components/button';
import type { Tab } from './use-modal-state';

type Props = {
  activeTab: Tab;
  hasSelection: boolean;
  onSavePreferences: () => void;
  onNecessaryOnly: () => void;
  onAcceptAll: () => void;
  onCustomise: () => void;
};

const ModalFooter = ({
  activeTab,
  hasSelection,
  onSavePreferences,
  onNecessaryOnly,
  onAcceptAll,
  onCustomise,
}: Props) => (
  <div className="shrink-0 flex gap-4 px-4 pb-5">
    {activeTab === 'details' ? (
      <>
        {hasSelection ? (
          <Button
            variant="secondary"
            size="lg"
            onClick={onSavePreferences}
            className="flex-1 h-[45px]"
          >
            Allow Selection
          </Button>
        ) : (
          <Button
            variant="secondary"
            size="lg"
            onClick={onNecessaryOnly}
            className="flex-1 h-[45px]"
          >
            Necessary Only
          </Button>
        )}
        <Button
          variant="primary"
          size="lg"
          onClick={onAcceptAll}
          className="flex-1 h-[45px]"
        >
          Allow All
        </Button>
      </>
    ) : (
      <>
        <Button
          variant="secondary"
          size="lg"
          onClick={onCustomise}
          className="flex-1 h-[45px]"
        >
          Customise
        </Button>
        <Button
          variant="primary"
          size="lg"
          onClick={onAcceptAll}
          className="flex-1 h-[45px]"
        >
          Allow All
        </Button>
      </>
    )}
  </div>
);

export default ModalFooter;
